<template>
  <div>
    <Pane />
    
    <div class="container">
      <div class="panel">资产基本信息</div>
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产编码">
              <a-input
                :disabled="true"
                v-decorator="[
                  'assetCode',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产类别">
              <a-select
              :disabled="true"
                v-decorator="[
                  'categoryId',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                style="width: 100%"
              >
                <a-select-option
                  v-for="item in assetsCategoryList"
                  :key="item.id"
                  :value="item.id"
                >
                  <div>
                    {{ item.subCategoryName }}
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="品牌型号">
              <a-input
              :disabled="true"
                v-decorator="[
                  'brandModel',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="采购日期">
              <a-date-picker
              :disabled="true"
                format="YYYY-MM-DD"
                v-decorator="[
                  'procurementTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="采购价格(元)">
              <a-input-number
              :disabled="true"
                style="width: 100%"
                :min="1"
                v-decorator="[
                  'purchasePrice',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产负责人">
              <EmployeeSelector
                @change="
                  (arr) => {
                    if (arr.length) {
                      selectedUser = arr[0];
                    } else {
                      selectedUser = {};
                    }
                  }
                "
                :value="selectedUser.name ? [selectedUser] : []"
              >
                <a-button block style="text-align: left" :disabled="true">
                  <div v-if="selectedUser.name">
                    {{ selectedUser.name }}
                  </div>
                  <div v-else>&nbsp;</div>
                </a-button>
              </EmployeeSelector>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产位置(部门)">
              <a-select
              :disabled="true"
                v-decorator="[
                  'deptId',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="财务编码">
              <a-input
              :disabled="true"
                v-decorator="[
                  'financialCode',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="启用日期">
              <a-date-picker
              :disabled="true"
                format="YYYY-MM-DD"
                v-decorator="[
                  'startTime',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="资产状态">
              <a-select
                :disabled="true"
                v-decorator="[
                  'status',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废方式">
              <a-select
              :disabled="true"
                v-decorator="[
                  'scrapMethod',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option v-for="item in ['平均年限法']" :key="item" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废时限(月)">
              <a-input-number
              :disabled="true"
                style="width: 100%"
                :min="1"
                v-decorator="[
                  'scrapLimitMonths',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="净残值率">
              <a-input-number
              :disabled="true"
                style="width: 100%"
                :min="0"
                :max="1"
                v-decorator="[
                  'netSalvageRate',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="备注">
              <a-textarea
              :disabled="true"
                v-decorator="[
                  'remark',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <div class="panel">资产记录</div>
      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        :pagination="false"
      >
        <a-table-column title="发生时间">
          <template slot-scope="text">{{  text.operateTime.split("T")[0] + " " + text.operateTime.split("T")[1].split(".")[0] }}</template>
        </a-table-column>
        <a-table-column title="操作人" data-index="operatorName"> </a-table-column>
        <a-table-column title="操作内容" data-index="actionDetail"> </a-table-column>
      </a-table>
      <div class="center">
        <a-space>
          <a-button @click="$close($route.path)">关闭</a-button>
        </a-space>
      </div>  
    </div>
  </div>
</template>

<script>
import moment from "moment";
import request from "@/api/request";
import { mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import organization from "@/mixins/organization";
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: "post",
  });
}
function getRecord(id) {
  return request({
    url: "/office-service/fixed-asset/getRecord/" + id,
  });
}
export default {
  mixins: [organization],
  name: "editFixedAssets",

  data() {
    return {
      list: [],
      assetsCategoryList: [],
      form: this.$form.createForm(this),
      loading: false,
      id: null,
      selectedUser: {},
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status");
    },
  },
  components: {
    EmployeeSelector,
  },
  mounted() {
    fetchList({
      pageNum: 1,
      pageSize: 10000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.assetsCategoryList = res.list;
      }
    });
    const { id } = this.$route.query;
    this.id = id;
    if (id) {
      this.loading = true;
      request({
        url: `/office-service/fixed-asset/get/${id}`,
        method: "get",
      })
        .then((res) => {
          this.form.setFieldsValue(res);
          this.selectedUser = {
            userId: res.responsiblePersonId,
            name: res.responsiblePersonName,
          };
        })
        .finally(() => {
          this.loading = false;
        });
      getRecord(id).then((res) => {
        console.log(res);
        this.list = res
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  methods: {


  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.center {
  margin-top: 80px;
}
.panel {
  margin-top: 20px;
  margin-bottom: 5px;
  font-size: 18px;
  color: #333;
}
</style>
